/* eslint-disable internal-rules/no-restricted-design-system-props */
/* eslint-disable internal-rules/no-restricted-design-system-imports */
import type { HTMLAttributes } from 'react';

import { Avatar, Link, Text } from '@change/ds-core-ui/next';

import { useDecisionMakerResponseByLine } from './hooks/useDecisionMakerResponseByLine';

export function DecisionMakerResponseByLine(props: HTMLAttributes<HTMLDivElement>) {
	const {
		data: { author },
	} = useDecisionMakerResponseByLine();

	return (
		<div className="mb-6 mt-6 flex items-start gap-[12px] md:mb-[52px] md:mt-[52px]" {...props}>
			<Avatar size="large" src={author.photoUrl} alt="" />
			<div className="flex flex-1 flex-col items-start gap-1">
				<Text variant="body" className="text-ellipsis" size="large" fontWeight="bold">
					{author.profileUrl ? (
						<Link href={author.profileUrl}>
							<Text variant="body" className="text-ellipsis" size="large" fontWeight="bold">
								{author.displayName}
							</Text>
						</Link>
					) : (
						author.displayName
					)}
				</Text>
				{author.title && (
					<Text variant="body" size="medium" className="text-typography-weak text-ellipsis">
						{author.title}
					</Text>
				)}
			</div>
		</div>
	);
}
